module.exports = __webpack_public_path__ + "fonts/9131f395-46ef-4940-8480-8ff008c42e59.5862be63.woff";